import axios from "axios";
import { MessageBox, Message} from "element-ui";
import store from "@/store";
import { getToken,removeToken } from "@/utils/auth";
import router from "@/router";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000, // 延长到15秒，避免接口慢直接超时
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    if (config.isAuth && store.getters.token) {
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
let flag = false;
// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.status === 200) {
      return res;
    } else if (res.status === 401) {
      if (flag) return;
      MessageBox.confirm("您的登录过期，请重新登录！", "请重新登录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (getToken()) {
            removeToken();
          }
          router.push({ name: "Login" });
        })
        .catch((err) => {
          console.log(err);
          // router.push({ name: "Login" });
        });
      flag = true;
      setTimeout(() => {
        flag = false;
      }, 2000);

    } else {
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(res.msg || "Error");
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    // Message({
    //   message: "系统异常,请刷新再试",
    //   type: "error",
    //   duration: 5 * 1000,
    // });
   
    return Promise.reject(error);
  }
);

export default service;
